import { useEffect, useRef } from 'react';
import Chartjs from 'chart.js/auto';

// 대시보드 전용 pie 차트.

interface AipPieChartProps {
  label: string; // 접근성 라벨
  labels: string[]; // 조각 라벨 (출처명)
  data: number[]; // 조각 값 (건수)
}

// 조각 색상 (공통 Chart와 동일 팔레트)
const SLICE_COLORS = ['#69A5FF', '#FF8C8C', '#FFC06E', '#88F03E', '#9E86FC'];

const AipPieChart: React.FC<AipPieChartProps> = ({ label, labels, data }) => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const chartRef = useRef<Chartjs | null>(null);

  useEffect(() => {
    if (!canvasRef.current) return;

    chartRef.current = new Chartjs(canvasRef.current, {
      type: 'pie',
      data: {
        labels,
        datasets: [
          {
            data,
            backgroundColor: data.map((_, i) => SLICE_COLORS[i % SLICE_COLORS.length]),
            borderColor: '#fff',
            borderWidth: 2,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              padding: 20,
              boxWidth: 15,
              boxHeight: 15,
              font: { family: 'Pretendard, sans-serif', size: 14 },
            },
          },
        },
      },
    });

    return () => {
      chartRef.current?.destroy();
    };
  }, [labels, data]);

  return <canvas ref={canvasRef} role="img" aria-label={label} />;
};

export default AipPieChart;
